import styled from 'styled-components'

export const StyledVideo = styled.video``

export const StyledSource = styled.source``
